module.exports = __webpack_public_path__ + "img/pencil.6bbfd4e5.svg";